import React from 'react'
import styled from 'styled-components'
import * as media from '../media'
import AutoPartCardBrief from '../finwhale/common/auto-part-card-brief'
import _ from 'lodash'
import {compose, lifecycle, withState} from 'recompose'
import {getAttributes, getTemplate} from "../itemtype"
import getUrl from "../getUrl";
import Loader from "../basic/LoaderCircle";
import LoaderLine from "../basic/LoaderLine";
import getImgUrl from "../getImgUrl";
import CategoryTypeSwitcher from '../finwhale/common/search/category-type'
import TranslateText from 'src/text/modal'


const Articul = styled.div`
  display: inline-block;
  padding: 7px 14px 6px;
  border-radius: 30px;
  background: rgb(235, 235, 235);
`

const Header = styled.div`
  margin: 40px auto;
  margin-bottom: 40px;
  font-size: 24px;
  font-weight: 800;
  ${media.smallerThan(700)`text-align: center;`}
`

const selection = ({total, categoryCount, cards, selected, setSelected, manufacturer_name, model_name, generation_name, variant_name, engine_name, type, setType, loadingCards, loadingYellow}) => (
  <div>
    <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>
        <Header>
          <TranslateText
            id="search__title"
            helperChips={{
              labels: [
                ['<<total>> - всего запчастей'],
                ['<<category-count>> - в категориях']
              ],
              example: 'Для указанного автомобиля найдено <<total>> запчастей в <<category-count>> категориях.'
            }}
            render={text => {
              text = text
                .replace('<<total>>', total || 0)
                .replace('<<category-count>>', categoryCount || 0);

              return <div>{text}</div>;
            }}
          />
        </Header>
        {
          loadingYellow
            ? <LoaderLine/>
            :
            <p style={{fontSize: 18, color: 'rgb(134, 149, 157)', marginBottom: 20}}>
              {manufacturer_name} {model_name} {generation_name} {variant_name} {engine_name}
            </p>
        }
        {
          loadingCards
            ? <Loader/>
            : <CategoryTypeSwitcher cards={cards} selected={selected} setSelected={setSelected}/>
        }

        {
          loadingCards
            ? <Loader/>
            : <div
              style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between'}}
            >{
            (cards ? Object.keys(cards) : []).map((key) => {
              return (

                    (cards[key] || [])
                      .filter(c => {
                        // Этот ключ не требуется переводить, ипользуется для внутренней логики
                        return selected == 'Все' || selected == c.type_name
                      })
                      .map(c => {
                        return (
                          <AutoPartCardBrief
                            img={getImgUrl(`/media/static/product_photos/${c.article}.png`)}
                            href={`/item/${c.id}`}
                            title={c.attribute_lang.display_name}
                            output={c.output}
                            style={{
                              maxWidth: 'calc(50% - 10px)',
                              marginTop: 10,
                              marginBottom: 10,
                              flex: 1,
                              flexBasis: '40%',
                              alignSelf: 'stretch'
                            }}
                          />
                        )
                      })

              )

            })}
            </div>
        }
      </div>
    </div>
)

const enhance = compose(
  lifecycle({
    state: {},

    componentDidUpdate(prevProps) {
      const manufacture = _.get(this.props, 'location.query.manufacturer_id')
      const model = _.get(this.props, 'location.query.model_id')
      const generation = _.get(this.props, 'location.query.generation_id')
      const variant = _.get(this.props, 'location.query.variant_id')
      const engine = _.get(this.props, 'location.query.engine_id')

      const manufacture2 = _.get(prevProps, 'location.query.manufacturer_id')
      const model2 = _.get(prevProps, 'location.query.model_id')
      const generation2 = _.get(prevProps, 'location.query.generation_id')
      const variant2 = _.get(prevProps, 'location.query.variant_id')
      const engine2 = _.get(prevProps, 'location.query.engine_id')

      if (manufacture != manufacture2 || model != model2 || generation != generation2 || variant != variant2 || engine != engine2) {
        this.setState({loadingCards: true})
        fetch(getUrl(`/cat/v1/searchitem/?manufacturer_id=${manufacture}&model_id=${model}&generation_id=${generation}&variant_id=${variant}${engine ? `&engine_id=${engine}` : ''}`)).then(data => {
          return data.json()
        }).then(listItems => {
          const ids = (_.get(listItems, 'data.data', []) || []).reduce((result, e) => {
            result = [...result, ...(_.get(e, 'list_id', []) || [])]
            return result
          }, [])
          const promises = ids.reduce((result, id) => {
            if (id) {
              result.push(fetch(getUrl(`/cat/v1/item?id=${id}`)))
            }
            return result
          }, [])
          const whenCompleted = Promise.all(promises)
          whenCompleted.then((responses) => {
            const jsons = responses.map(data => data.json())
            Promise.all(jsons).then((jsons) => {
              let cards = jsons.map(e => _.get(e, 'data.data[0]'))
              const total = cards.length
              const attributes = getAttributes(cards)
              cards = cards.map((c, i) => {
                const template = getTemplate(c.type_id);
                return {
                  ...c,
                  data: attributes[i],
                  output: {
                    article: {
                      key: template.code.title,
                      value: c.article,
                    },
                    weight: {
                      key: template.weight.title,
                      value: c.attribute_lang.weight,
                    },
                    size_package: {
                      key: template.size_package.title,
                      value: c.attribute_lang.size_package,
                    },
                    applicability: {
                      key: template.applicability.title,
                      value: c.attribute_lang.applicability,
                    },
                    complete: {
                      key: template.complete.title,
                      value: c.attribute_lang.complete,
                    },
                  },
                }
              })
              cards = _.groupBy(cards, 'type_name')
              const categoryCount = Object.keys(cards).length
              this.setState({cards, total, categoryCount, loadingCards: false})
            })
          })
        }).catch(err => {
          console.log(err)
        })

        this.setState({ loadingYellow: true })
        fetch(getUrl(`/cat/v1/dict/variantline/${variant}`)).then((data) => {
          return data.json()
        }).then(json => {
          const variantLine = _.get(json, 'data.data[0]')
          this.setState({
            manufacturer_name: variantLine.manufacturer_id.name,
            model_name: variantLine.model_id.name,
            generation_name: variantLine.generation_id.name,
            variant_name: variantLine.variant_id.name,
            engine_name: variantLine.engine_id || '',
            loadingYellow: false,
          })
        }).catch(err => {
          console.log(err)
        })
      }
    },

    componentDidMount() {
      const manufacture = _.get(this.props, 'location.query.manufacturer_id')
      const model = _.get(this.props, 'location.query.model_id')
      const generation = _.get(this.props, 'location.query.generation_id')
      const variant = _.get(this.props, 'location.query.variant_id')
      const engine = _.get(this.props, 'location.query.engine_id')
      this.setState({ loadingCards: true })
      fetch(getUrl(`/cat/v1/searchitem/?manufacturer_id=${manufacture}&model_id=${model}&generation_id=${generation}&variant_id=${variant}${engine ? `&engine_id=${engine}` : ''}`)).then(data => {
        return data.json()
      }).then(listItems => {
        const ids = (_.get(listItems, 'data.data', []) || []).reduce((result, e) => {
          result = [...result, ...(_.get(e, 'list_id', []) || [])]
          return result
        }, [])
        const promises = ids.reduce((result, id) => {
          if (id) {
            result.push(fetch(getUrl(`/cat/v1/item?id=${id}`)))
          }
          return result
        }, [])
        const whenCompleted = Promise.all(promises)
        whenCompleted.then((responses) => {
          const jsons = responses.map(data => data.json())
          Promise.all(jsons).then((jsons) => {
            let cards = jsons.map(e => _.get(e, 'data.data[0]'))
            const total = cards.length
            const attributes = getAttributes(cards)
            
            cards = cards.map((c, i) => {
              const template = getTemplate(c.type_id);
              return {
                ...c,
                data: attributes,
                output: {
                  article: {
                    key: template.code.title,
                    value: c.article,
                  },
                  weight: {
                    key: template.weight.title,
                    value: c.attribute_lang.weight,
                  },
                  size_package: {
                    key: template.size_package.title,
                    value: c.attribute_lang.size_package,
                  },
                  applicability: {
                    key: template.applicability.title,
                    value: c.attribute_lang.applicability,
                  },
                  complete: {
                    key: template.complete.title,
                    value: c.attribute_lang.complete,
                  },
                },
              }
            })

            cards = _.groupBy(cards, 'type_name')
            const categoryCount = Object.keys(cards).length
            this.setState({cards, total, categoryCount,loadingCards : false})
          })
        })
      }).catch(err => {
        console.log(err)
      })

      this.setState({ loadingYellow: true })
      fetch(getUrl(`/cat/v1/dict/variantline/${variant}`)).then((data) => {
        return data.json()
      }).then(json => {
        const variantLine = _.get(json, 'data.data[0]')
        this.setState({
          manufacturer_name: variantLine.manufacturer_id.name,
          model_name: variantLine.model_id.name,
          generation_name: variantLine.generation_id.name,
          variant_name: variantLine.variant_id.name,
          engine_name: variantLine.engine_id || '',
          loadingYellow: false,
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }),
  withState('selected', 'setSelected', 'Все'),
)

export default enhance(selection)



// WEBPACK FOOTER //
// ./src/pages/selection.js